import { defineMessages } from "react-intl";

export const messages = defineMessages({
    feedbackSubmittedTitle: {
        id: "fastshift.feedback-collector.feedback-submitted-title",
        defaultMessage: "Thanks!",
        description: "Title for the feedback submitted flag"
    },
    feedbackSubmittedDescription: {
        id: "fastshift.feedback-collector.feedback-submitted-description",
        defaultMessage:
            "Your valuable feedback helps us continually improve our products.",
        description: "Description for the feedback submitted flag"
    },
    iconButtonLabel: {
        id: "fastshift.feedback-collector.icon-button-label",
        defaultMessage: "open customer feedback collector",
        description: "Label for the icon button"
    }
});
